"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
const getAttendanceMarkedEvent_1 = require("../helpers/getEvent/getAttendanceMarkedEvent");
const getProgressMeasureUpdatedEvent_1 = require("../helpers/getEvent/getProgressMeasureUpdatedEvent");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
function setPropertiesOfMeta(properties, state) {
    if (!isEmpty_1.default(properties)) {
        state.meta = JSON.stringify(Object.assign({}, JSON.parse(state.meta || '{}'), { properties: [properties] }));
    }
}
function setProgressMeasureUsingAttendace(attendance, sessionState) {
    if (attendance) {
        sessionState.progressMeasure = 1;
        sessionState.scaledProgressMeasure = 1;
        return;
    }
    sessionState.progressMeasure = 0;
    sessionState.scaledProgressMeasure = 0;
    return;
}
function markAttendanceILTSessionWithSessionState(command, user, sessionState) {
    const { sessionId, timeStamp, attendance, properties = {}, contentId } = command;
    const { userId, companyId } = user;
    const events = [];
    const currentProgressMeasure = sessionState.progressMeasure;
    setPropertiesOfMeta(properties, sessionState);
    setProgressMeasureUsingAttendace(attendance, sessionState);
    sessionState.updatedAt = timeStamp;
    if (currentProgressMeasure !== sessionState.progressMeasure) {
        const contentType = entity_1.ContentType.ILT_SESSION;
        const progressMeasureUpdatedEvent = getProgressMeasureUpdatedEvent_1.getProgressMeasureUpdatedEvent(command, companyId, userId, `${contentId}_${sessionId}`, contentType, currentProgressMeasure, sessionState.progressMeasure);
        events.push(progressMeasureUpdatedEvent);
        const attendanceMarkedEvent = getAttendanceMarkedEvent_1.getAttendanceMarkedEvent(command, companyId, userId, contentId, contentType, attendance, properties, sessionId);
        events.push(attendanceMarkedEvent);
    }
    return events;
}
function applyMarkAttendanceILTSessionCommand(command, user, states) {
    const { sessionId } = command;
    const { userId } = user;
    const events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const sessionState = getState_1.getStateByContentIdUserId(draftStates, sessionId, userId);
        if (!sessionState || ![entity_1.ILTRegisterType.ASSIGNED, entity_1.ILTRegisterType.ENROLLED].includes(sessionState.registerType)) {
            throw new Error('User not registered to session: ' + sessionId);
        }
        const sessionStateEvents = markAttendanceILTSessionWithSessionState(command, user, sessionState);
        events.push(...sessionStateEvents);
    });
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyMarkAttendanceILTSessionCommand = applyMarkAttendanceILTSessionCommand;
//# sourceMappingURL=applyMarkAttendanceILTSessionCommand.js.map